import { WaitingListService } from '@/services/waiting-list.service';
import type { CreateWaitingListRequestDto } from '@/types/dto/waiting-list.dto';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const waitingListQueryKeys = {
  all: ['waiting-list'] as const,
};

export function useCreateWaitingList() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (payload: CreateWaitingListRequestDto) => WaitingListService.create(payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: waitingListQueryKeys.all }),
  });

  return {
    ...mutation,
    createWaitingList: mutation.mutateAsync,
  };
}
